// ─────────────────────────────────────────────
// CONFIGURAÇÃO AZURE AD — edite antes do deploy
// ─────────────────────────────────────────────
export const msalConfig = {
  auth: {
    clientId: "f78c7d26-d7e3-458c-bc6b-be83dcc9b198",
    // App registrada no próprio tenant da Power Tuning (single-tenant).
    authority: "https://login.microsoftonline.com/768c55c0-eb69-48bd-8862-d6860f585ed6",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

// Azure Blob Storage
export const STORAGE_CONFIG = {
  accountName:   "intranetpowertuning",
  containerName: "sites",
  blobName:      "links.json",
  sasToken:      "sp=rw&st=2026-04-24T11:36:58Z&se=2026-12-01T19:51:58Z&spr=https&sv=2025-11-05&sr=c&sig=qPgTbdyKbxzws1kHq0N3exzFRg94vTEdXOmcVWop5ZI%3D",
};
